// extracted by mini-css-extract-plugin
export default {"text":"_2a6KPpfUpquvUPXLGC_Dg-"};